import React, {useState} from 'react';
import {useStaticQuery, graphql} from 'gatsby';
import {getImage, GatsbyImage} from 'gatsby-plugin-image';

import {cn} from '../lib/helpers';

import Button from './button';
import Heading from './heading';
import Link from './link';
import Logo from './logo';
import LogoIcon from './logoIcon';

import {
  subNavLinkStyle,
  navWrapper,
  container,
  logoLink,
  logo,
  openNav,
  callToActionWrapper,
  callToActionButton,
  navLinkUrakoitsijalle,
  navLink,
  subNavWrapper,
  subNavHeading,
  avainlippuNega,
  avainlippuSininen,
} from './header.module.css';

const SubNavLink = ({children, to = '/', ...rest}) => (
  <Link to={to} className={subNavLinkStyle} {...rest}>
    {children}
  </Link>
);

const Header = ({showLogin = false, hideNav = false}) => {
  const [showNav, setShowNav] = useState(false);

  const data = useStaticQuery(graphql`
    query HeaderJobsQuery {
      allSanityJob(filter: {showOnHomePage: {eq: true}}, sort: {name: ASC}) {
        edges {
          node {
            name
            slug {
              current
            }
          }
        }
      }
      avainlippuNega: file(relativePath: {eq: "avainlippu-nega.png"}) {
        childImageSharp {
          gatsbyImageData(width: 30, quality: 90)
        }
      }
      avainlippuSininen: file(relativePath: {eq: "avainlippu-sininen.png"}) {
        childImageSharp {
          gatsbyImageData(width: 30, quality: 90)
        }
      }
    }
  `);

  return (
    <nav aria-label="main navigation" className={navWrapper}>
      <div className={container}>
        <Link to="/" className={logoLink}>
          <LogoIcon />
          <Logo className={logo} />
        </Link>
        {!hideNav ? (
          <>
            <div
              role="button"
              tabIndex={0}
              aria-label="Avaa valikko"
              data-target="navMenu"
              onClick={() => setShowNav(!showNav)}
              onKeyDown={({key}) => key === 'Enter' && setShowNav(!showNav)}
              className={openNav}
            >
              <svg viewBox="0 0 100 80" width="20" height="20">
                <rect width="100" height="10" rx="3"></rect>
                <rect y="30" width="100" height="10" rx="3"></rect>
                <rect y="60" width="100" height="10" rx="3"></rect>
              </svg>
            </div>
            <div
              className={callToActionWrapper}
              style={{
                display: showNav ? 'flex' : null,
              }}
            >
              <Link
                to="/urakoitsijalle"
                className={cn(navLink, navLinkUrakoitsijalle)}
              >
                Urakoitsijalle
              </Link>
              {showLogin && (
                <Link
                  href="https://app.urakkadiili.fi/"
                  rel="nofollow"
                  className={navLink}
                >
                  Kirjaudu
                </Link>
              )}
              <Button
                as="a"
                href="https://app.urakkadiili.fi/tarjouspyynnot/uusi"
                rel="nofollow"
                className={callToActionButton}
              >
                Kilpailuta remonttisi
              </Button>
            </div>
            <div
              id="subNavMenu"
              className={subNavWrapper}
              style={{
                display: showNav ? 'block' : null,
              }}
            >
              <Heading as="div" className={subNavHeading}>
                Remontin tilaajalle
              </Heading>
              <SubNavLink to={'/remonttien-hinnat'} bgDark="dark">
                Remonttien hinnat
              </SubNavLink>
              <SubNavLink to={'/artikkelit'} bgDark="dark">
                Artikkelit
              </SubNavLink>
              <SubNavLink to={'/remonttilaina'} bgDark="dark">
                Remonttilaina
              </SubNavLink>
              <Heading as="div" className={subNavHeading}>
                Suosituimmat palvelut
              </Heading>
              {data.allSanityJob.edges.map(({node: {name, slug}}, i) => (
                <SubNavLink to={`/${slug.current}-hinta`} key={i} bgDark="dark">
                  {name}
                </SubNavLink>
              ))}
            </div>
          </>
        ) : (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              order: '3',
              flex: '1',
              justifyContent: 'flex-end',
              paddingRight: '24px',
            }}
          >
            <div className={avainlippuNega}>
              <GatsbyImage
                image={getImage(data.avainlippuNega)}
                alt="Avainlippu"
              />
            </div>
            <div className={avainlippuSininen}>
              <GatsbyImage
                image={getImage(data.avainlippuSininen)}
                alt="Avainlippu"
                className={avainlippuSininen}
              />
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Header;
